var render = function (_h,_vm) {var _c=_vm._c;return _c('b-button',{attrs:{"href":_vm.props.href,"target":"_blank"}},[_vm._v(" Baixar Resultado VTK ")])}
var staticRenderFns = []

export { render, staticRenderFns }